import React from 'react';
import {DashboardView} from '../dashboard/types';
import {RefreshCw} from 'lucide-react';

interface HeaderProps {
  activeView: DashboardView;
  greetingName: string;
  authEmail: string;
  now: Date;
  isLoading: boolean;
  onToggleCalendar: () => void;
  onRefresh: () => void;
}

const Header: React.FC<HeaderProps> = ({
  activeView,
  greetingName,
  authEmail,
  now,
  isLoading,
  onToggleCalendar,
  onRefresh,
}) => {
  return (
    <header className='board-header'>
      <div>
        <h1>Hello {greetingName || 'there'} !</h1>
        <p className='header-subtitle'>
          {activeView === 'profile'
            ? 'Manage your account details.'
            : activeView === 'messages'
              ? 'Review customer contact messages.'
              : 'Here is your daily statistic'}
        </p>
      </div>
      <div className='header-meta'>
        <span className='user-email-chip'>{authEmail || 'admin'}</span>
        <div className='header-meta-row'>
          <div className='calendar-wrap'>
            <button
              type='button'
              className='date-chip date-trigger'
              onClick={onToggleCalendar}>
              {now.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </button>
          </div>
          <button
            onClick={onRefresh}
            disabled={isLoading}>
            {isLoading ? 'Loading...' : <RefreshCw />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
